import type { LogsEvent } from '@datadog/browser-logs'

import { sanitizeUrl, sanitizeUrlsInText } from '@/utils/redaction/sanitize-url'

import { redactErrorText } from './redact-error-text'

/** The logs counterpart of redactRumEvent: console-forwarded logs carry the
 *  error text in the message itself, and network logs carry the request url. */
export function redactLogsEvent(event: LogsEvent): void {
  event.message = sanitizeUrlsInText(event.message)
  event.view.url = sanitizeUrl(event.view.url)
  if (event.view.referrer !== undefined) {
    event.view.referrer = sanitizeUrl(event.view.referrer)
  }
  if (event.http !== undefined) {
    event.http.url = sanitizeUrl(event.http.url)
  }
  if (event.error !== undefined) {
    redactErrorText(event.error)
  }
}
